<div class="holding">
  <div class="header-container">
    <app-navbar></app-navbar>
  </div>

  <div (click)="onEdit()" class="search-wrapper container-xl container-fluid">
    <div class="search-container d-flex flex-row align-items-center">
      <i class="ti ti-search"></i>
      <div class="d-flex flex-column">
        <p *ngIf="country" class="bold">{{ country.code | countryName : country.name }}</p>
        <p *ngIf="region" class="light">{{ region.name | placeName }}</p>
        <p *ngIf="district" class="light">{{ district.name | placeName }}</p>
        <p *ngIf="!district && !region" class="light">{{ 'All Regions' |
          translate }}</p>
      </div>
    </div>
  </div>
</div>
<div #filteringRef [class.stuck]="isStuck" [attr.aria-hidden]="isStuck ? 'true' : null"
  class="filtering container-xl container-fluid d-flex flex-row justify-content-between align-items-center d-md-flex">
  <button type="button" class="btn btn-link text-black" (click)="onSort()">
    <i class="ti ti-arrows-sort">
      <span *ngIf="currentSorting != 'averageRate-desc'  " class="red-dot position-absolute top-0 "></span>
    </i>{{'Order' | translate}}

  </button>
  <button type="button" class="btn btn-link text-black" (click)="onFilter()">
    <i class="ti ti-filter fs-20">
      <span *ngIf="searchService.selectedLanguage != 'wl'" class="red-dot position-absolute top-0 "></span>
    </i>{{'Filter' | translate}}

  </button>
  <button type="button" class="btn btn-link text-black" (click)="onEdit()">
    <i class="ti ti-pencil"> </i>{{'Edit' | translate}}
  </button>
</div>

<div *ngIf="isStuck" class="filtering-spacer" [style.height.px]="filteringHeight"></div>

<div class="filtering px-3 d-flex flex-row justify-content-between align-items-center sticky d-md-none"
  [class.visible]="isStuck" [attr.aria-hidden]="isStuck ? 'false' : 'true'">
  <button type="button" class="btn btn-link text-black" (click)="onSort()">
    <i class="ti ti-arrows-sort">
      <span *ngIf="currentSorting != 'averageRate-desc'  " class="red-dot position-absolute top-0 "></span>
    </i>{{'Order' | translate}}

  </button>
  <button type="button" class="btn btn-link text-black" (click)="onFilter()">
    <i class="ti ti-filter fs-20">
      <span *ngIf="searchService.selectedLanguage != 'wl'" class="red-dot position-absolute top-0 "></span>
    </i>{{'Filter' | translate}}

  </button>
  <button type="button" class="btn btn-link text-black" (click)="onEdit()">
    <i class="ti ti-pencil"> </i>{{'Edit' | translate}}
  </button>
</div>